import { render, staticRenderFns } from "./MovimientoCreate.vue?vue&type=template&id=323e852f&scoped=true&"
import script from "./MovimientoCreate.vue?vue&type=script&lang=js&"
export * from "./MovimientoCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323e852f",
  null
  
)

export default component.exports